var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7 5.90018H3.95538L7.57768 2.27788C8.00778 1.84778 8.00778 1.15258 7.57768 0.722477C7.14758 0.292377 6.45238 0.292377 6.02228 0.722477L0.522282 6.22248C0.092182 6.65258 0.092182 7.34778 0.522282 7.77788L6.02228 13.2779C6.23678 13.4924 6.51838 13.6002 6.79998 13.6002C7.08158 13.6002 7.36318 13.4924 7.57768 13.2779C8.00778 12.8478 8.00778 12.1526 7.57768 11.7225L3.95538 8.10018H16.7C17.3083 8.10018 17.8 7.60738 17.8 7.00018C17.8 6.39298 17.3083 5.90018 16.7 5.90018Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.c4260d3d3fd8c3f843891821adbf0edc.svg";
export { ForwardRef as ReactComponent };